// import * as React from 'react';
// import styled from 'styled-components';//emotion:chakuraUI(型付与)
// import * as ethers from 'ethers';
// import { useTranslation } from 'react-i18next';
// import { useRecoilValue } from "recoil";
// import { configJsonState } from "../../states/configJsonState";


// type Props = {
//     // browserWalletAddress:string,
//     // languageExchange:any,
// }
// export const TweetButton: React.FC<Props> = (props) => {
//     const configStatus = useRecoilValue(configJsonState);
//     const TweetButtonImage = styled.img`
//         margin-bottom: 26px;
//         display: block;
//         width: 224px;
//         text-align: center;
//         margin-left: auto;
//         margin-right: auto;
//     `;
//     React.useEffect(()=>{
//         (async() => {

//         })()
//     },[]);
//   return (
//     <TweetButtonImage 
//         src='https://www.sushitop.io/7nftsealer/bata/cagamefi/twtterbutton.png' 
//         onClick={()=>{
//             window.open(`https://twitter.com/intent/tweet?text=${configStatus.insertTweetText}`)
//         }}
//     />
//    );
// };





import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@chakra-ui/react';
import { AiOutlineTwitter } from 'react-icons/ai';
import { getedNFTState } from '../../states/getedNFTState';
import { useRecoilState, useRecoilValue } from 'recoil';
import { configJsonState } from "../../states/configJsonState";

type Props = {
    // languageExchange:any,
}

export const TweetButton: React.FC<Props> = (props) => {
    const configStatus = useRecoilValue(configJsonState);
    const [t, i18n] = useTranslation();
    const [getedNFTStatus , setGetedNFTStatus ] = useRecoilState(getedNFTState);
    // const tweetContent = `${getedNFTStatus.tokenId}番目のNFT【${getedNFTStatus.name}】をGetしました！`;
    const tweetContent = configStatus.insertTweetText;
    const shareToTwitter = () => {
        const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetContent)}`;
        window.open(url);
    };

    return(
        <>
            <Button
                width="217px"
                height="34px"
                colorScheme={`twitter`}
                borderRadius="100px"
                color='#F7F8FC'
                fontSize="14px"
                fontWeight={600}
                leftIcon={<Icon as={AiOutlineTwitter} boxSize={6} />}
                onClick={shareToTwitter}
                zIndex={1}
            >
                {t(`Twitterでシェアする`)}
            </Button>
        </>
    );
}
